import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import Link from "next/link";
import { usePathname, useSearchParams } from "next/navigation";

const CollectionPagination = (props) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const params = new URLSearchParams(searchParams);

  const buildLink = (page) => {
    params.set("page", page.toString());
    return `${pathname}?${params.toString()}`;
  };

  return (
    <Pagination
      {...props}
      renderItem={(item) => (
        <PaginationItem component={Link} href={buildLink(item.page)} {...item} />
      )}
    />
  );
};

export default CollectionPagination;
